import { type UseQueryResult, useQuery } from 'react-query';
import * as wealthlaneCustomerServices from '@wealthlane/api-services/wealthlane-customer-service';
import { TradeOrderSharedService } from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetTradeOrderStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const tradeOrderStatus = useQuery(
    ['getTradeOrderStatus'],
    async () => {
      return await handleRequest(
        TradeOrderSharedService.getApiAwardSettlementApiAppTradeOrderTradeOrderStatus()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return tradeOrderStatus;
};

export default useGetTradeOrderStatus;
